import React, { Component } from 'react';
import { Collapse, Navbar, NavbarBrand, NavbarToggler, NavItem, NavLink } from 'reactstrap';
import { Link } from 'react-router-dom';
import './NavMenu.css';
import LoginMenu from './LoginMenu'
import DashboardMenu from './DashboardMenu'
import logo from './../../images/logo_smsJET.png';
export class NavMenu extends Component {
    static displayName = NavMenu.name;
    constructor(props) {
        super(props);

        this.toggleNavbar = this.toggleNavbar.bind(this);
        this.state = {
            collapsed: true
        };
    }

    toggleNavbar() {
        this.setState({
            collapsed: !this.state.collapsed
        });
    }

    render() {
        return (
            <header>
                <Navbar expand="sm" dark className="navbar-dark box-shadow" style={{ background: "#212529" }}>
                    <div className="container d-flex align-items-center justify-content-between w-100 mw-100">
                        <NavbarBrand tag={Link} to="/">
                            <img className="navbar-logo" src={logo} alt="Logo" />
                        </NavbarBrand>
                        <NavbarToggler onClick={this.toggleNavbar} className="mr-2" />
                        <Collapse className="d-sm-inline-flex flex-sm-row"  isOpen={!this.state.collapsed} navbar>
                            <ul className="navbar-nav flex-grow ml-auto">
                                <NavItem>
                                    <NavLink tag={Link} className="text-white" to="/">Główna</NavLink>
                                </NavItem>
                                <DashboardMenu />
                                <NavItem>
                                    <NavLink tag={Link} className="text-white" to="/help">Pomoc</NavLink>
                                </NavItem>
                                <LoginMenu />
                            </ul>
                        </Collapse>
                    </div>
                </Navbar>
            </header>

        );
    }
}
